import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useSellers } from 'hooks'
import { useCallback, useEffect, useMemo } from 'react'
import { Item } from 'typings'

type Props = {
  name: string
  form: FormState
}

export function useLoader(props: Props) {
  const { name, form } = props

  const sellers: Item[] | undefined = useWatch({
    form,
    name,
  })

  const updateSellers = useCallback(
    (sellersWithId: Item[]) => {
      const items: Item[] | undefined = form.getValues(name)
      if (!items || !items.length) return

      const updatedSellers = items.map((item) => ({
        ...item,
        name:
          sellersWithId.find((seller) => seller.id === item.id)?.name ??
          item.name,
      }))

      const changed = updatedSellers.some(
        (item, index) => item.name !== items[index].name
      )
      if (changed) {
        form.setValue(name, updatedSellers)
      }
    },
    [form, name]
  )

  const sellersToRequest = useMemo(() => sellers ?? [], [sellers])

  const { data } = useSellers({
    options: {
      enabled: sellersToRequest.length > 0,
    },
  })

  useEffect(() => {
    if (data) {
      updateSellers(data)
    }
  }, [data, updateSellers])
}
